import { Dictionary } from 'src/app/core/model/dictionary';
import { Address } from 'src/app/member/model/member';

export class FacilityEdit
{
    public id = null;
    public version = 0;
    public name = '';
    public description = '';
    public npi = '';
    public telephoneNumber = '';
    public telephoneNumberExtension = '';
    public cellPhoneNumber = '';
    public faxNumber = '';
    public url = '';
    public address: Address;
    public streetLine: string;
    public streetLineAdditional: string;
    public city: string;
    public county: string;
    public postalCode: string;
    public state: Dictionary;
    public country: Dictionary;
}
